export const API = process.env.VUE_APP_API;

export const blueToothCommandTest = 31;  
export const setLightCalibrationCommand = 63; 
export const setLightCalibrationCommandEnd = 65; 
export const getCalibrationCommand = 67; 

export const startMultimetrCommand = 70; 
export const stopMultimetrCommand = 71; 
export const switchTransitorOnCommand = 72; 
export const switchTransitorOffCommand = 73; 
export const setCurrentCalibrationCommand = 74;
export const setCurrentCalibrationCommandEnd = 75;

export const CommandUseSmallCurrent = 32;  
export const CommandUseBigCurrent = 33;  
export const CommandMpptOn = 40;  
export const CommandMpptOff = 42;